module.exports = __webpack_public_path__ + "img/kakeibo-budget-planner_B09K21NWY7.960a0b9c.jpg";